var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.display)?_c('button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.__('Scroll to TOP')),expression:"__('Scroll to TOP')"}],ref:"toTop",staticClass:"btn btn-primary btn-position",on:{"click":function($event){$event.preventDefault();return _vm.scrollToTop.apply(null, arguments)}}},[_c('i',{staticClass:"fas fa-angle-up"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }